export const formatSocialHandle = (socialHandle) => {
  let formattedHandle = socialHandle.split("");
  if (formattedHandle[0] === "@") {
    formattedHandle.shift();
  }
  formattedHandle = formattedHandle.join("").toString();
  return formattedHandle;
};
